import { Icon } from "oddsgate-ds";
import { useEffect, useRef, useState } from "react";
import { IHelloBar } from "./HelloBar.interface";
import { StyledHelloBar, StyledHelloBarCloseButton, StyledHelloBarContent, StyledHelloBarLink, StyledHelloBarSeparator, StyledHelloBarText } from "./HelloBar.theme";
import { gsap } from "gsap";

const HelloBar = ({ helloBarText, helloBarCTALabel, helloBarCTAUrl } : IHelloBar) => {
    const [isVisible, setIsVisible] = useState(false);
    const helloBarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (sessionStorage.getItem('helloBarClosed') !== 'true') {
            setIsVisible(true);
        }
    }, []);

    const handleClose = () => {
        if (helloBarRef.current) {
            gsap.to(helloBarRef.current, {
                height: 0,
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0,
                duration: 0.3,
                ease: 'power2.inOut',
                onComplete: () => {
                    sessionStorage.setItem('helloBarClosed', 'true');
                    setIsVisible(false);
                }
            });
        }
    };

    if (!isVisible) {
        return null;
    }

    return (
        <StyledHelloBar ref={helloBarRef} className="font-epilogue">
            <StyledHelloBarContent>
                <StyledHelloBarText>{helloBarText}</StyledHelloBarText>
                {helloBarCTALabel && helloBarCTAUrl && <StyledHelloBarSeparator />}
                {helloBarCTALabel && helloBarCTAUrl && (
                    <StyledHelloBarLink href={helloBarCTAUrl}>
                        {helloBarCTALabel}
                    </StyledHelloBarLink>
                )}
            </StyledHelloBarContent>
            <StyledHelloBarCloseButton onClick={handleClose}>
                <Icon icon="icon-close" />
            </StyledHelloBarCloseButton>
        </StyledHelloBar>
    );
}

export default HelloBar;